(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('manual-help', {
            parent: 'entity',
            url: '/manual-help?doc&section',
            data: {
                authorities: [
                    'ROLE_DATA_OPERATOR',
                    'ROLE_READ_ONLY',
                    'ROLE_AREA_MANAGEMENT',
                    'ROLE_COLLECTOR',
                    'ROLE_AI_ASSISTANT',
                    'ROLE_ADMIN',
                    'ROLE_SUPER_ADMIN'
                ],
                pageTitle: 'Documentation'
            },
            views: {
                'content@': {
                    templateUrl: 'app/business/manual-help/manual-help.html',
                    controller: 'ManualHelpController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        });
    }
})();
